/**
 * Centralized frontend environment configuration.
 * Supports both REACT_APP_API_URL (documented) and legacy REACT_APP_URL.
 */
const apiBase =
  process.env.REACT_APP_API_URL ||
  process.env.REACT_APP_URL ||
  'https://api.cubegames.ca/api';


const socketBase =
  apiBase.replace(/\/api\/?$/, '') ||
  process.env.REACT_APP_SOCKET_URL ||
  'https://api.cubegames.ca';

console.log(apiBase, socketBase);

export const API_BASE_URL = apiBase;
export const SOCKET_URL = socketBase;
